import React, { useEffect, useState } from "react";
import Shopsubbanner from "../../components/shopsubbanner";
import ProductGrid from "../../components/ProductGrid";

const Toffee = ({ products, loading, error }) => {
  const [bannerImage, setBannerImage] = useState(
    "https://res.cloudinary.com/dtivafy25/image/upload/v1749818247/Derby_04_xlidla.jpg" // Desktop
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateBanner = () => {
      if (window.innerWidth <= 768) {
        // Mobile banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1754649145/01_t5lxne.jpg");
      } else {
        // Desktop banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1749818247/Derby_04_xlidla.jpg");
      }
    };

    updateBanner(); // Set initial banner on mount
    window.addEventListener("resize", updateBanner);

    return () => {
      window.removeEventListener("resize", updateBanner);
    };
  }, []);

  return (
    <>
      <Shopsubbanner image_url={bannerImage} />
      <ProductGrid category="Toffee" products={products} loading={loading} error={error} />
    </>
  );
};

export default Toffee;
